export const SEARCH_PRESET_TYPE_KEY = '__presetType';

export type SearchPresetType = 'talent-search' | 'job-offer-scoring';

type PresetTaggedFilters = Record<string, unknown> & {
    [SEARCH_PRESET_TYPE_KEY]?: SearchPresetType;
};

export const attachSearchPresetType = <TFilters extends object, TPresetType extends SearchPresetType>(
    filters: TFilters,
    presetType: TPresetType,
): TFilters & { [SEARCH_PRESET_TYPE_KEY]: TPresetType } => ({
    ...filters,
    [SEARCH_PRESET_TYPE_KEY]: presetType,
});

export const stripSearchPresetType = <TFilters>(filters: TFilters): TFilters => {
    if (!filters || typeof filters !== 'object' || Array.isArray(filters)) {
        return filters;
    }

    const nextFilters = { ...(filters as PresetTaggedFilters) };
    delete nextFilters[SEARCH_PRESET_TYPE_KEY];

    return nextFilters as TFilters;
};

export const matchesSearchPresetType = (
    filters: unknown,
    presetType: SearchPresetType,
    allowLegacy = false,
): boolean => {
    if (!filters || typeof filters !== 'object' || Array.isArray(filters)) {
        return false;
    }

    const taggedFilters = filters as PresetTaggedFilters;

    if (!taggedFilters[SEARCH_PRESET_TYPE_KEY]) {
        return allowLegacy;
    }

    return taggedFilters[SEARCH_PRESET_TYPE_KEY] === presetType;
};
